<ng-container *ngIf="voucher.voucherUrl">
  <iframe #VoucherIframe [hidden]="hideIframe" [src]="voucher.voucherUrl | safeUrl"></iframe>
</ng-container>
